module.exports = __webpack_public_path__ + "img/info.9e221731.svg";